var render = function () {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "plan-slot borderAsRuolo",
      class: "ruolo_" + _vm.Constants.RUOLO[_vm.ruolo_abc],
    },
    [
      _vm.associato
        ? _c(
            "div",
            {
              staticClass: "btn btn-associa associato",
              class:
                ((_obj = {}),
                (_obj["ruolo_" + _vm.Constants.RUOLO[_vm.ruolo_abc]] = true),
                _obj),
              attrs: { depressed: "" },
            },
            [
              _c("v-icon", { staticClass: "checked" }, [_vm._v("done")]),
              _vm._v(" "),
              _c("div", { staticClass: "pos" }, [_vm._v(_vm._s(_vm.i + 1))]),
            ],
            1
          )
        : _c(
            "v-btn",
            {
              staticClass: "btn btn-associa",
              class:
                ((_obj$1 = {
                  evidenzia: _vm.onlyAssociaSlot,
                }),
                (_obj$1["ruolo_" + _vm.Constants.RUOLO[_vm.ruolo_abc]] = true),
                _obj$1),
              attrs: { depressed: "", disabled: _vm.readonly },
              on: {
                click: function ($event) {
                  _vm.overrideAssociaClick
                    ? _vm.overrideAssociaClickCb()
                    : _vm.associaCalciatore()
                },
              },
            },
            [_vm._v("\n\n    " + _vm._s(_vm.i + 1) + "\n    ")]
          ),
      _vm._v(" "),
      _vm.associato
        ? _c(
            "div",
            { staticClass: "nomi-calciatori associato" },
            [
              _vm._v("\n    " + _vm._s(_vm.nomeCalciatoreAssociato) + "\n    "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: {
                    small: "",
                    icon: "",
                    disabled: _vm.onlyAssociaSlot || _vm.readonly,
                  },
                  on: { click: _vm.disassocia },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "navy--text", attrs: { small: "" } },
                    [_vm._v("close")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("v-autocomplete", {
            staticClass: "nomi-calciatori",
            attrs: {
              items: _vm.autocompleteItems,
              disabled: _vm.onlyAssociaSlot || _vm.readonly,
              placeholder: "...",
              "hide-details": "",
              "hide-no-data": "",
              "single-line": "",
              "solo-inverted": "",
              flat: "",
              dark: "",
              dense: "",
              "deletable-chips": "",
              multiple: "",
              "auto-select-first": "",
            },
            on: { blur: _vm.saveCalciatori },
            model: {
              value: _vm.pCalciatori,
              callback: function ($$v) {
                _vm.pCalciatori = $$v
              },
              expression: "pCalciatori",
            },
          }),
      _vm._v(" "),
      _vm.associato
        ? _c(
            "div",
            {
              staticClass: "btn crediti-pianificati associato",
              attrs: { depressed: "" },
            },
            [_vm._v("\n    " + _vm._s(_vm.pagato) + "\n  ")]
          )
        : _c(
            "v-btn",
            {
              staticClass: "btn crediti-pianificati btn--depressed",
              attrs: { disabled: _vm.onlyAssociaSlot || _vm.readonly },
              on: { click: _vm.showNumpad },
            },
            [_vm._v(_vm._s(_vm.pCrediti == 0 ? "..." : _vm.pCrediti))]
          ),
      _vm._v(" "),
      _vm.append
        ? _c(
            "div",
            [
              _c("v-icon", { staticClass: "white--text" }, [
                _vm._v("chevron_right"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.append
        ? _c("div", { staticClass: "new-plan" }, [
            _vm._v("\n    " + _vm._s(_vm.append) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }